import { amountConstants } from '../_constants/amount.constants'

const INITIAL_STATE = {
  amount: 0,
}

const amountReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case amountConstants.GET_AMOUNT:
      return Object.assign({}, state, {
        amount: action.payload.amount,
      })
    default:
      return state
  }
}

export default amountReducer
